import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'summary'
})
export class SummaryPipe implements PipeTransform {
  transform(
    value?: string | number | null,
    placeholder: string = '-',
    prefix: string = '',
    suffix: string = ''
  ): string | null {
    if (
      placeholder &&
      (value === null || value === undefined || value === '')
    ) {
      return placeholder;
    }

    const summaryValue = value?.toString() ?? null;
    return summaryValue ? `${prefix}${summaryValue}${suffix}` : null;
  }
}
